import type { AreYouOkChannel as AreYouOkChannelType } from '@server/are-you-ok/are-you-ok-channel.dto';
import { AreYouOkChannelEnum } from '@server/are-you-ok/are-you-ok-channel.dto';

export const mapToChannel = (code: string): AreYouOkChannelType => {
  if (code === 's') return AreYouOkChannelEnum.Sms;
  if (code === 'e') return AreYouOkChannelEnum.Email;
  throw new Error(`Channel code '${code}' not allowed`);
};
